import { PollType } from './types';
import svStrings from '../../../sv-strings';
export const pollTypeString: Record<PollType, string> = {
  playerofthematch: svStrings.polls.pollTypePlayerOfTheMatch,
  playerofthemonth: svStrings.polls.pollTypePlayerOfTheMonth,
  coachofthemonth: svStrings.polls.pollTypeCoachOfTheMonth,
  quiz: svStrings.polls.pollTypeQuiz,
  free: svStrings.polls.pollTypeText,
};
